import { createApiSlice } from "@common";
import { CRUD_QUALIFICATION_READINESS } from "@routes";

const apiConfig = [
  {
    name: "addQualificationReadiness",
    method: "post",
    url: CRUD_QUALIFICATION_READINESS,
    stateKey: "message",
  },
  {
    name: "getQualificationReadiness",
    method: "get",
    url: CRUD_QUALIFICATION_READINESS,
    stateKey: "data",
  },
  {
    name: "updateQualificationReadiness",
    method: "put",
    url: CRUD_QUALIFICATION_READINESS,
    stateKey: "message",
  },
  {
    name: "deleteQualificationReadiness",
    method: "delete",
    url: CRUD_QUALIFICATION_READINESS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("qualificationReadiness", apiConfig, customReducers);
const qualificationReadinessSlice = slice;

export default qualificationReadinessSlice.reducer;

export const {
  addQualificationReadiness,
  getQualificationReadiness,
  updateQualificationReadiness,
  deleteQualificationReadiness,
} = thunks;

export const { rowSelect } = actions;
